export default process.env.VUE_APP_DEVICE === 'mobile'
  ? require('@platform-shared/utils/rememberToken.mobile.js').default
  : require('@platform-shared/utils/rememberToken.web.js').default
